import * as z from "zod";

export const getTiktokAdsAccounts = {
  name: "getTiktokAdsAccounts" as const,
  input: z.null(),
  output: z.object({
    accounts: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
};
